const checkRedux = (state=[],action) => {
    switch(action.type){
        case 'CHECK_REDUX':
            return action.payload
        default:
            return state;
    }
}

export default checkRedux;